import { AuthFooter } from "../../../components/Footer/AuthFooter.jsx";
import { LoginForm } from "../../../components/Form/LoginForm";
import { AuthNav, SignNav } from "../../../components/Navbar/Webpages/AuthNav";

const Login = () => {
  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden bg-white">
      <SignNav />
      <div className=" flex-grow">
        <div className="container mx-auto  max-w-screen-xl  ">
          <div className="md:w-128  md:mx-auto mt-16 mx-4">
            <LoginForm />
          </div>
        </div>
      </div>

      <AuthFooter />
    </div>
  );
};

export default Login;
